import React, { useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IProps } from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import selectors from '@state/selectors';
import ErrorIcon from '@assets/icons/errorIcon';
import BlackCheckIcon from '@assets/icons/blackCheckIcon';
import Tooltip from '@components/Tooltip';

const SaveStatus : React.FC<IProps> = () => {
  const [connection, setConnection] = useState(true);
  const [init, setInit] = useState(true);  
  let { saveStatus, parsedTreeInfo, onSavingParsedTree} = useContext(Context);
  const updatedElementsResponse = useSelector(selectors.parsedTrees.getUpdatedElementsResponse);
  const updatedFieldResponse = useSelector(selectors.parsedTrees.getUpdatedFieldResponse);

  useEffect(() => {
    if (updatedElementsResponse) onSavingParsedTree(false);
  }, [updatedElementsResponse]);
  
  useEffect(() => {
    if (updatedFieldResponse) onSavingParsedTree(false);
  }, [updatedFieldResponse]);

  useEffect(() => {    
    if (saveStatus.showSavingStatus) setInit(false);
  }, [saveStatus.showSavingStatus]);

  const changeStatus = () => setConnection(navigator.onLine);

  useEffect(() => {
    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);

  const dateFormat = (createdDate: Date, updateDate: Date) => {
    let dateType = (createdDate===updateDate) ? new Date(createdDate) : new Date(updateDate);
    let text = (createdDate===updateDate) ? 'Created' : 'Last Edited';
    let today = new Date();

    if (dateType.getFullYear() === today.getFullYear() && dateType.getMonth() === today.getMonth() && dateType.getDate() === today.getDate())
        return `${text} Today ${new Intl.DateTimeFormat('en-US',{ hour:'2-digit', minute:'2-digit'}).format(dateType)}`;
    else
        return `${text} ${new Intl.DateTimeFormat('en-US', { day:'2-digit', month:'2-digit', year:'2-digit', hour:'2-digit', minute:'2-digit'}).format(dateType)}`;  
  }

  const nameFormat = () => {
    return (parsedTreeInfo.createdDate===parsedTreeInfo.updateDate) ?
              `By ${parsedTreeInfo.createdBy?.name}`:
              parsedTreeInfo.updatedBy?.name && `By ${parsedTreeInfo.updatedBy.name}`
  }

  const dateformat = () => {
    return parsedTreeInfo?.updateDate 
            ? <Tooltip tip={nameFormat()}>
                {dateFormat(parsedTreeInfo.createdDate, parsedTreeInfo.updateDate)}
              </Tooltip>
            : '';
  }
  
  return (
    <S.Root>
        <S.Label>
        { !connection ? 'Not Connected to Internet':
          init
            ? dateformat()           
            : saveStatus.savingParsedTree && saveStatus.showSavingStatus ? 'Saving...' :
              ((updatedElementsResponse===undefined || (updatedElementsResponse && (updatedElementsResponse >= 200 && updatedElementsResponse <= 300))) 
              && (updatedFieldResponse===undefined || (updatedFieldResponse && (updatedFieldResponse >= 200 && updatedFieldResponse <= 300)))
              ) 
                ? <>Saved! <BlackCheckIcon style={{width: 15, height:15, marginTop: "-2px", marginLeft: "5px" }}/></>
                : <>Error: Progress not saved <ErrorIcon style={{width: 15, height:15, marginTop: "-2px", marginLeft: "5px" }}/></>
        }
        </S.Label>
    </S.Root>
  );
}

export default SaveStatus;